import React, { useEffect, useId, useMemo, useState } from "react";
import FormGroup from "../../../components/forms/FormGroup";
import { FormLabel } from "../../../components/forms";
import InputErrorMessage from "../../../components/forms/InputErrorMessage";
import FormSelect, { CalculateClassName, CalculateSelectStyles } from "../../../components/forms/FormSelect";
import useMasterAccountProjects from "../hooks/useMasterAccountProjects";
import { ClientProjectSelectOption } from "../../../components/forms/selects/ClientProjectSelect";

export const ClientProjectSelectComponents = {
    Option: ClientProjectSelectOption
};

const MasterAccountProjectPagedSelect = ({
    className = "w-100",
    components = { ...ClientProjectSelectComponents },
    errorMessage = null,
    horizontal = false,
    id,
    isMulti = false,
    label,
    masterAccountId,
    errorAllowRetry,
    setValue = () => console.warn('set value method has not been assigned.'),
    value,
    ...rest
}) => {

    const defaultId = useId();
    const componentId = id || defaultId;
    const [error, setError] = useState(errorMessage);
    const { data, hasMore, isFetching, isLoading, nextPage } = useMasterAccountProjects(masterAccountId);
    const currentClassName = useMemo(() => CalculateClassName(className, false, error), [className, error]);
    const currentStyles = useMemo(() => CalculateSelectStyles(error), [error]);

    const handleOnMenuScrollToBottom = (_) => {
        if (hasMore === false) {
            return;
        }
        nextPage();
    };

    return <FormGroup horizontal={horizontal}>
        {label && <FormLabel htmlFor={componentId} horizontal={horizontal}>{label}</FormLabel>}
        <FormSelect
            id={componentId}
            isMulti={isMulti}
            isDisabled={!masterAccountId}
            components={components}
            styles={currentStyles}
            className={currentClassName}
            defaultValueObject={value?.value ? value : null}
            defaultValue={value}
            options={data}
            isLoading={isLoading || isFetching}
            onChange={setValue}
            onMenuScrollToBottom={handleOnMenuScrollToBottom}
            {...rest}
        />
        <InputErrorMessage error={error} allowRetry={errorAllowRetry} />
    </FormGroup>

};

export default MasterAccountProjectPagedSelect;